
import { ServiceNotImplementedException } from "@/lib/exceptions/http";
import { CancelToken } from "@/lib/utility/cancelToken";
import { handleError } from "@/lib/utility/handleError";
import { BasePagination } from "@/store/modules/base-pagination.store";
import { BackwardsCompatiblePaginatedStore } from "@/store/backwards-compatible-paginated.store";
import { Component, Vue } from "vue-property-decorator";

/**
 * Offers services to load data for a paginated list
 */
@Component({})
export default class PaginationListVueMixin extends Vue {
  isLoadingMore = false;
  loadingAll = true;

  /**
   * TODO: Type this
   * skipped this because it leads to too many errors to handle quickly
   */
  getModule(): BasePagination<any, any> | BackwardsCompatiblePaginatedStore<any, any> {
    throw new ServiceNotImplementedException("getModule");
  }

  get items() {
    return this.getModule().paginationList;
  }

  async loadMore(query = {}) {
    try {
      this.isLoadingMore = true;
      await this.loadAllFromLastId(query);
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoadingMore = false;
    }
  }

  async loadAllFromLastId(query = {}) {
    if (this.items.length === 0) {
      await this.getModule().fetchAllFromBeginning(query);
    } else {
      this.getModule().cancelToken?.requestCancellation();
      const cancelToken = new CancelToken();
      this.getModule().setCancelToken(cancelToken);
      await this.getModule().fetchRest({
        query,
        cancelToken
      });
    }
  }

  async refresh(query = {}) {
    this.loadingAll = true;
    // using any here because not casting leads to error saying that empty list doesnt exist on both possible types, casting to the right one leads to error saying that the method is defined anyways so its pointless ot make the if
    if ((this.getModule() as any).emptyList) {
      (this.getModule() as BasePagination<any, any>).emptyList();
    }
    await this.getModule().fetchAllFromBeginning(query);

    this.loadingAll = false;
  }
}
